'use strict';

document.querySelector('.header__list').onclick = () => {
  document.querySelector('.header__toggler').checked = false;
};
